export class MakeModelCreate {
    makeId: number;
    modelId: number;
    makeValue: string;
    modelValue: string;
    vehicleTypeId: number;
}
